var $77ac944da51b7354$exports = {};
const $77ac944da51b7354$var$form = document.getElementById('contact-form');
const $77ac944da51b7354$var$thanks = document.getElementById('contact-thanks');
$77ac944da51b7354$var$form.addEventListener('submit', (e)=>{
    e.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    fetch("/", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams(formData).toString()
    }).then(()=>{
        form.hidden = true;
        $77ac944da51b7354$var$thanks.hidden = false;
    }).catch((error)=>console.log(error));
});
// Hero cursor-following glow
const $77ac944da51b7354$var$hero = document.getElementById('hero');
$77ac944da51b7354$var$hero.addEventListener('mousemove', (e)=>{
    const rect = $77ac944da51b7354$var$hero.getBoundingClientRect();
    $77ac944da51b7354$var$hero.style.setProperty('--glow-x', `${Math.round(e.clientX - rect.left)}px`);
    $77ac944da51b7354$var$hero.style.setProperty('--glow-y', `${Math.round(e.clientY - rect.top)}px`);
    $77ac944da51b7354$var$hero.style.setProperty('--glow-opacity', '1');
});
$77ac944da51b7354$var$hero.addEventListener('mouseleave', ()=>{
    $77ac944da51b7354$var$hero.style.setProperty('--glow-opacity', '0');
});


//# sourceMappingURL=repo.9fca921e.js.map
